// 이벤트 목록/상세에서 쓰는 통합 카드 모델.
// 웰컴쿠폰은 쿠폰 발급 버튼이 달린 특수 이벤트라 코드에 고정(static), 나머지는 어드민이 만드는 DB 이벤트.
export interface EventListItem {
  id: string;        // 'welcome-coupon' 또는 숫자 id 문자열
  title: string;
  imageUrl: string;  // 화면에 바로 쓰는 URL (정적자산은 그대로, 업로드는 toImageUrl 적용된 값)
  ended: boolean;
}

// 첫구매 감사 쿠폰 (특수 이벤트, 항상 목록 최상단)
export const WELCOME_EVENT: EventListItem = {
  id: 'welcome-coupon',
  title: 'First Purchase Thank-You Coupon',
  imageUrl: '/welcome-event.png',
  ended: false,
};
